import List from "../layout/List";
import Listitem from "../layout/Listitem";

const AuctionShipping = () => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="w-[25%]">
        <div className="flex items-center justify-between">
          <List className="mt-7 flex flex-col gap-y-6">
            <Listitem
              className="font-pop text-xs font-semibold text-darkGreen"
              itemname="Shipping"
            />
            <Listitem
              className="font-pop text-xs font-semibold text-darkGreen"
              itemname="Seller accepts"
            />
            <Listitem
              className="font-pop text-xs font-semibold text-darkGreen"
              itemname="Warranty"
            />
            <Listitem
              className="font-pop text-xs font-semibold text-darkGreen"
              itemname="Gurantee"
            />
          </List>
        </div>
      </div>
      <div className="mt-7 flex w-[75%] flex-col gap-y-2">
        <div className="flex gap-x-2">
          <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
            Collection
          </p>
          <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
            Courier
          </p>
        </div>
        <div className="flex w-full items-center justify-between">
          <div className="flex gap-x-2 ">
            <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
              Cash
            </p>
            <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
              Eft
            </p>
            <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
              Bitcoin
            </p>
          </div>
        </div>
        <div className="flex items-center gap-x-2">
          <p className="rounded-md bg-quantityColor py-1 px-8 font-pop text-sm font-semibold text-primary">
            6 months dealer
          </p>
          <button className="rounded-lg bg-primary px-2.5 font-pop text-2xl font-bold text-white">
            +
          </button>
        </div>
        <div className="flex items-center gap-x-2">
          <p className="rounded-md bg-quantityColor py-1 px-4 font-pop text-sm font-semibold text-primary">
            Money-Back 30 Days
          </p>
          <button className=" rounded-lg bg-primary px-2.5 font-pop text-2xl font-bold text-white">
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuctionShipping;
